/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'm18.7 14.3-1.4 1.4-4.6-4.6a1 1 0 0 0-1.4 0l-4.6 4.6-1.5-1.4L12 7.6l6.7 6.7Z',
  DEV ? 'ChevronUpIcon' : '',
  '',
  false,
);
